module.exports = __webpack_public_path__ + "media/images/xpass/markers/active/stride-e9ddb12b8c78c76df78c712cf10f48f5.png";